import React from 'react';

const LoadDistribution = ({ data }) => {
  if (!data) return null;

  const { totalCompleted, totalRemaining, percentComplete, easy, quality, long, rest, planned } = data;

  const total = parseFloat(totalCompleted) + parseFloat(totalRemaining);
  
  // Helper for progress bars
  const Bar = ({ label, valueString, color }) => {
      // Parse "1/3" string or fallback to 0/1
      const parts = (valueString || "0/0").split('/');
      const current = parseFloat(parts[0]) || 0;
      const target = parseFloat(parts[1]) || 1;
      const percentage = Math.min(100, (current / target) * 100);

      return (
          <div className="mb-3">
              <div className="flex justify-between text-xs mb-1">
                  <span className="text-gray-400">{label}</span>
                  <span className="text-gray-300">{valueString}</span>
              </div>
              <div className="h-1.5 bg-gray-700 rounded-full overflow-hidden">
                  <div 
                      className={`h-full ${color}`} 
                      style={{ width: `${percentage}%` }}
                  ></div>
              </div>
          </div>
      );
  };

  return (
    <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
         <h3 className="text-gray-400 text-xs uppercase tracking-wider mb-4">Volume & Intensity</h3>
         
         {/* Overall Progress */}
         <div className="mb-6 text-center">
             <div className="relative inline-flex items-center justify-center">
                 <svg className="w-24 h-24 transform -rotate-90">
                     <circle cx="48" cy="48" r="40" stroke="currentColor" strokeWidth="8" fill="transparent" className="text-gray-700" />
                     <circle cx="48" cy="48" r="40" stroke="currentColor" strokeWidth="8" fill="transparent" 
                        strokeDasharray={251.2} 
                        strokeDashoffset={251.2 - (251.2 * percentComplete / 100)} 
                        className="text-blue-500" 
                     />
                 </svg>
                 <span className="absolute text-2xl font-bold text-white">{percentComplete}%</span>
             </div>
             <p className="text-xs text-gray-400 mt-2">
                 {totalCompleted} of {Math.round(total)} km completed
             </p>
         </div>

         {/* Breakdown */}
         <div className="space-y-4">
             <Bar label="Easy / Recovery" valueString={easy} color="bg-green-500" />
             <Bar label="Long Run" valueString={long} color="bg-orange-500" />
             <Bar label="Quality / Speed" valueString={quality} color="bg-yellow-500" />
             <Bar label="Rest Days" valueString={rest} color="bg-blue-500" />
         </div>
    </div>
  );
};

export default LoadDistribution;
